import React from 'react';
import { X } from 'phosphor-react';
import './SFooterDrawer.css';

export interface SFooterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  height?: string;
  children: React.ReactNode;
  className?: string;
}

export const SFooterDrawer: React.FC<SFooterDrawerProps> = ({
  isOpen,
  onClose,
  title = '',
  height = '50vh',
  children,
  className = '',
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`s-footer-drawer-overlay ${isOpen ? 'open' : ''}`}
        onClick={handleOverlayClick}
      />

      {/* Drawer */}
      <div
        className={`s-footer-drawer ${isOpen ? 'open' : ''} ${className}`}
        style={{ height }}
      >
        {/* Handle indicator */}
        <div className="s-footer-drawer-handle" onClick={onClose} />

        {/* Header */}
        <div className="s-footer-drawer-header">
          {title && <h3 className="s-footer-drawer-title">{title}</h3>}
          <button className="s-footer-drawer-close" onClick={onClose}>
            <X size={24} color="currentColor" />
          </button>
        </div>

        {/* Content */}
        <div className="s-footer-drawer-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default SFooterDrawer;
